import { apiClient } from '@/plugins/axios'; // Import your axios instance


const getSales = async (filters: Record<string, any> = {}) => {
  const params = new URLSearchParams(filters as any);
  return apiClient.get('/sales?' + params.toString()); // Let the error bubble up
};

const getSaleById = async (id: number) => {
  return await apiClient.get(`/sales/${id}`); // Fetch car listing by ID
};

const createSale = async (saleData: any) => {
  return await apiClient.post('/sales', saleData); // Create a new car listing
};

const updateSale = async (id: number, saleData: any) => {
  return await apiClient.patch(`/sales/${id}`, saleData); // Update car listing by ID
};

const deleteSale = async (id: number) => {
  return await apiClient.delete(`/sales/${id}`); // Delete car listing by ID
};
/*
const getSoldByUser = async (filters: Record<string, any> = {}) => {
  const params = new URLSearchParams(filters as any);
  return apiClient.get('/dashboard/sold-by-user?' + params.toString()); // Let the error bubble up
};
const getSoldByMedium = async (filters: Record<string, any> = {}) => {
  const params = new URLSearchParams(filters as any);
  return apiClient.get('/dashboard/sold-by-medium?' + params.toString()); // Let the error bubble up
};
const getSoldByPoster = async (filters: Record<string, any> = {}) => {
  const params = new URLSearchParams(filters as any);
  return apiClient.get('/dashboard/sold-by-poster?' + params.toString()); // Let the error bubble up
};
const getSoldByProduct = async (filters: Record<string, any> = {}) => {
  const params = new URLSearchParams(filters as any);
  return apiClient.get('/dashboard/sold-by-product?' + params.toString()); // Let the error bubble up
};
const getSalesTotals = async (filters: Record<string, any> = {}) => {
  const params = new URLSearchParams(filters as any);
  return apiClient.get('/dashboard/sold-totals?' + params.toString()); // Let the error bubble up
};
*/
export default {
  getSales,
  getSaleById,
  createSale,
  updateSale,
  deleteSale,
  /*getSoldByUser,
  getSoldByMedium,
  getSoldByPoster,
  getSoldByProduct,
  getSalesTotals*/
};
